module.exports = __webpack_public_path__ + "static/assets/3eaa980c541fd8349e59d0b41c8d8427.svg";